// import custom elements first so they get defined as soon as possible.
import './components/PJax.js';
import './components/InfoDialog.js';
import './components/ConfirmDialog.js';
import './components/Alert.js';
import './components/Table.js';
import './components/DateFormatter.js';
import './components/JsonFormatter.js';
import './components/Autocomplete.js';
import './components/CopyToClipboard.js';
import './components/DisplayToggle.js';
import './components/DateTimeInput.js';
import './components/Share.js';

// import anything else
import setupLuxbarToggle from './luxbar';

setupLuxbarToggle();
